import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Moon, Clock, Tag } from "lucide-react";
import { RestaurantCard } from "@/components/customer/RestaurantCard";
import { EmptyState, SkelCard } from "@/components/common";
import { api } from "@/lib/api";

const FILTERS = [
  { k: "", l: "Open Now" },
  { k: "after_midnight", l: "Open After Midnight" },
  { k: "fast", l: "Fast Delivery" },
  { k: "budget", l: "Budget" },
];

export default function LateNight() {
  const nav = useNavigate();
  const [rests, setRests] = useState(null);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");

  useEffect(() => {
    setRests(null);
    const params = new URLSearchParams();
    if (filter) params.set("filter", filter === "" ? "open_now" : filter);
    if (filter === "") params.set("filter", "open_now");
    if (sort) params.set("sort", sort);
    api.get(`/late-night/restaurants?${params.toString()}`).then((r) => setRests(r.data)).catch(() => setRests([]));
  }, [filter, sort]);

  return (
    <div className="min-h-screen bg-surface max-w-[520px] mx-auto pb-24">
      <div className="sticky top-0 z-40 bg-gradient-to-br from-indigo-900 to-slate-900 text-white px-4 pt-3 pb-4 rounded-b-3xl">
        <div className="flex items-center gap-2">
          <button onClick={() => nav(-1)} className="w-9 h-9 flex items-center justify-center tap" data-testid="ln-back"><ArrowLeft size={22} /></button>
          <div className="flex items-center gap-2"><Moon size={20} /><h1 className="font-display font-bold text-lg">Late Night Eats</h1></div>
        </div>
        <p className="text-xs text-white/70 mt-1 ml-11">Restaurants serving right now, late into the night</p>
        <div className="flex gap-2 overflow-x-auto hide-scrollbar mt-3">
          {FILTERS.map((f) => (
            <button key={f.k} onClick={() => setFilter(f.k)} className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${filter === f.k ? "bg-white text-slate-900" : "bg-white/15 text-white"}`} data-testid={`ln-filter-${f.k || "open_now"}`}>{f.l}</button>
          ))}
          <button onClick={() => setSort(sort === "rating" ? "" : "rating")} className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${sort === "rating" ? "bg-white text-slate-900" : "bg-white/15 text-white"}`} data-testid="ln-sort-rating">Top Rated</button>
        </div>
      </div>

      <div className="px-4 py-4">
        {!rests ? (
          <div className="grid gap-4">{[0, 1, 2].map((i) => <SkelCard key={i} />)}</div>
        ) : rests.length === 0 ? (
          <EmptyState icon={Moon} title="No late-night spots right now" subtitle="Try changing the filter or check back later." testid="ln-empty" />
        ) : (
          <div className="grid gap-5" data-testid="ln-list">
            {rests.map((r) => (
              <div key={r.id} className="relative">
                <RestaurantCard r={r} wide />
                <div className="mt-1.5 flex items-center flex-wrap gap-2 text-[11px]">
                  <span className="inline-flex items-center gap-1 bg-indigo-100 text-indigo-700 font-bold px-2 py-0.5 rounded-md"><Moon size={11} /> Open Late</span>
                  {r.closing_time && <span className="inline-flex items-center gap-1 text-ink-600"><Clock size={11} /> Closes {r.closing_time}</span>}
                  {r.late_night_offer && <span className="inline-flex items-center gap-1 bg-amber-100 text-amber-700 font-bold px-2 py-0.5 rounded-md"><Tag size={11} /> {r.late_night_offer}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
